import React, { useState } from 'react';
import { ROOTS, canSee, rootOfView } from '../menuModel';
import { GROUPS } from '../linksData';

// Inner SVG markup for each icon name used in menuModel.js.
const P = {
  overview: '<path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/>',
  apps: '<rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/>',
  workspace: '<rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/>',
  hr: '<path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/>',
  admin: '<circle cx="12" cy="12" r="3"/><path d="M12 1v6m0 6v6M5.6 5.6l4.2 4.2m4.2 4.2l4.2 4.2M1 12h6m6 0h6M5.6 18.4l4.2-4.2m4.2-4.2l4.2-4.2"/>',
  it: '<rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/>',
  reports: '<path d="M3 3v18h18M18 17V9M13 17V5M8 17v-3"/>',
  chat: '<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>',
  drive: '<path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/>',
  gmail: '<path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/>',
  docusign: '<path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>',
  adobe: '<polyline points="4 20 12 4 20 20"/><line x1="8" y1="14" x2="16" y2="14"/>',
  zoom: '<polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2"/>',
  asana: '<circle cx="12" cy="6" r="3"/><circle cx="6" cy="17" r="3"/><circle cx="18" cy="17" r="3"/>',
  knowbe4: '<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M9 12l2 2 4-4"/>',
  inventory: '<rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/>',
  forms: '<path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/>',
  links: '<path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>',
  users: '<path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/>',
  invmgmt: '<rect x="3" y="3" width="18" height="18" rx="2"/><line x1="9" y1="3" x2="9" y2="21"/>',
  cal: '<rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>',
  shield: '<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M9 12l2 2 4-4"/>',
  departments: '<path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18"/><path d="M2 22h20"/><path d="M10 6h.01M14 6h.01M10 10h.01M14 10h.01M10 14h.01M14 14h.01M10 18h4"/>',
  facilities: '<path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>',
  settings: '<circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>',
  clipboard: '<path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><rect x="8" y="2" width="8" height="4" rx="1"/><path d="M9 12h6M9 16h4"/>',
  integrations: '<path d="M9 2v6M15 2v6M6 8h12M18 8v3a6 6 0 0 1-12 0V8M12 17v5"/>',
  people: '<path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/>',
  security: '<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><circle cx="12" cy="11" r="1"/><path d="M12 12v3"/>',
};

const Icon = ({ name, size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"
    dangerouslySetInnerHTML={{ __html: P[name] || '' }} />
);

// Ribbon + fly-out panel navigation (new UI theme). Renders entirely from
// menuModel.ROOTS, filtered by the same role gates as the classic sidebar, and
// drives the same navigateTo(view) the app already uses. No feature logic here.
export default function RibbonSidebar({
  user, currentView, navigateTo, staffList = [], chatUnreadCount = 0,
  onLogout, onEnterStaffMode, onOpenLinksCategory, linksCategory,
}) {
  const roots = ROOTS.filter(r => canSee(r.gate, user));
  const bottomRoots = roots.filter(r => r.zone === 'bottom');
  // Pinned roots sit at the bottom of the top group, just ABOVE the divider line.
  const pinnedRoots = roots.filter(r => r.zone !== 'bottom' && r.pinAboveDivider);
  const topRoots = roots.filter(r => r.zone !== 'bottom' && !r.pinAboveDivider);
  const activeRoot = rootOfView(currentView);

  // Which panel is open. Default to the panel that owns the current view (so the
  // relevant menu is visible on load); fall back to the first panel-type root.
  const [openId, setOpenId] = useState(() => {
    const r = activeRoot && activeRoot.type !== 'link' ? activeRoot : roots.find(x => x.type !== 'link');
    return r ? r.id : null;
  });
  const [menuOpen, setMenuOpen] = useState(false);

  const open = ROOTS.find(r => r.id === openId) || null;
  const visibleItems = open ? (open.items || []).filter(it => canSee(it.gate || 'all', user)) : [];

  const clickRoot = (r) => {
    if (r.type === 'link') { navigateTo(r.view); setOpenId(null); return; }
    const willOpen = openId !== r.id;
    setOpenId(willOpen ? r.id : null); // click active again → collapse
    if (!willOpen) return;
    if (r.kind === 'links') {
      // open Links → land on a category (keep the current one, else the first)
      onOpenLinksCategory && onOpenLinksCategory(linksCategory || (GROUPS[0] || {}).label);
    } else if (r.view) {
      navigateTo(r.view); // panel roots that also have a landing view
    }
  };

  const renderRib = (r) => {
    const isActive = openId ? r.id === openId : (activeRoot && r.id === activeRoot.id);
    return (
      <button key={r.id} className={`rb-item ${isActive ? 'active' : ''}`} onClick={() => clickRoot(r)}>
        <Icon name={r.icon} />
        <span className="rb-tip">{r.label}</span>
      </button>
    );
  };

  // avatar (same source as the classic sidebar footer)
  const me = staffList.find(s => s.id === user?.id);
  const initials =
    ((user?.first_name?.[0] || '') + (user?.last_name?.[0] || '')).toUpperCase() ||
    (user?.username?.[0] || 'U').toUpperCase();
  const displayName =
    user?.display_name || `${user?.first_name || ''} ${user?.last_name || ''}`.trim() || user?.username;
  // Show the true role (owner/admin/supervisor/staff), not the normalized one.
  const roleLabel = ({ owner: 'Owner', admin: 'Admin', supervisor: 'Supervisor', staff: 'Staff' })[user?.roleLabel || user?.role] || 'Staff';

  return (
    <>
      <nav className="rb-ribbon">
        {topRoots.map(renderRib)}
        <div className="rb-spacer" />
        {pinnedRoots.map(renderRib)}
        {bottomRoots.length > 0 && <div className="rb-divider" />}
        {bottomRoots.map(renderRib)}
      </nav>

      <aside className={`rb-panel ${open ? '' : 'collapsed'}`}>
        {open && (
          <div className="rb-panel-head">
            <span className="rb-pd-ico"><Icon name={open.icon} /></span>
            <h2>{open.label}</h2>
          </div>
        )}

        <div className="rb-panel-body">
          {!open && (
            <div style={{ padding: '6px 4px' }}>
              <div style={{ padding: '4px 8px 0', fontSize: 14.5, fontWeight: 700, color: '#0f172a' }}>
                Welcome{user?.first_name ? `, ${user.first_name}` : ''}
              </div>
              <div className="rb-group">Quick access</div>
              <button className="rb-nav-item" onClick={() => navigateTo('chat')}>
                <span className="rb-ni-ico"><Icon name="chat" size={15} /></span><span>Chat</span>
              </button>
              <button className="rb-nav-item" onClick={() => navigateTo('time-off')}>
                <span className="rb-ni-ico"><Icon name="cal" size={15} /></span><span>Time Off</span>
              </button>
              <button className="rb-nav-item" onClick={() => navigateTo('my-profile')}>
                <span className="rb-ni-ico"><Icon name="people" size={15} /></span><span>My Profile</span>
              </button>
            </div>
          )}
          {open && (
            <>
              {open.kind === 'links' && (
                <>
                  <div className="rb-group">Categories</div>
                  {GROUPS.map(g => (
                    <button
                      key={g.label}
                      className={`rb-nav-item ${g.label === linksCategory ? 'active' : ''}`}
                      onClick={() => onOpenLinksCategory && onOpenLinksCategory(g.label)}
                    >
                      <span className="rb-ni-ico">
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/></svg>
                      </span>
                      <span>{g.label}</span>
                      <span className="rb-count">{g.links.length}</span>
                    </button>
                  ))}
                </>
              )}
              {open.kind === 'apps' && <div className="rb-group">Your apps</div>}
              {open.kind !== 'links' && visibleItems.map(it => {
                const active = it.view && it.view === currentView;
                const inner = (
                  <>
                    {open.kind === 'apps'
                      ? <span className="rb-logo"><Icon name={it.icon} size={15} /></span>
                      : <span className="rb-ni-ico"><Icon name={it.icon} size={15} /></span>}
                    <span>{it.label}</span>
                    {it.soon && <span className="rb-soon">SOON</span>}
                    {it.badge === 'chat' && chatUnreadCount > 0 && (
                      <span className="rb-badge">{chatUnreadCount > 99 ? '99+' : chatUnreadCount}</span>
                    )}
                  </>
                );
                if (it.href) {
                  return (
                    <a key={it.label} className="rb-nav-item" href={it.href} target="_blank" rel="noopener noreferrer">
                      {inner}
                    </a>
                  );
                }
                return (
                  <button key={it.label} className={`rb-nav-item ${active ? 'active' : ''} ${it.soon ? 'soon' : ''}`}
                    disabled={it.soon} onClick={() => !it.soon && navigateTo(it.view)}>
                    {inner}
                  </button>
                );
              })}
            </>
          )}
        </div>

        <div className="rb-footer">
              {menuOpen && (
                <div className="rb-menu">
                  <button className="rb-menu-item" onClick={() => { setMenuOpen(false); navigateTo('my-profile'); }}>My Profile</button>
                  <button className="rb-menu-item" onClick={() => { setMenuOpen(false); navigateTo('account-settings'); }}>Account Settings</button>
                  <button className="rb-menu-item" onClick={() => { setMenuOpen(false); navigateTo('help-support'); }}>Help &amp; Support</button>
                  {user?.role === 'admin' && !user?.preview && (
                    <button className="rb-menu-item" onClick={() => { setMenuOpen(false); onEnterStaffMode && onEnterStaffMode(); }}>Enter Staff Mode</button>
                  )}
                  <div className="rb-menu-div" />
                  <button className="rb-menu-item danger" onClick={() => { setMenuOpen(false); onLogout && onLogout(); }}>Logout</button>
                </div>
              )}
              <button className="rb-usercard" onClick={() => setMenuOpen(v => !v)}>
                <span className="rb-avatar">
                  {me?.google_photo_url
                    ? <img src={me.google_photo_url} alt={initials} />
                    : me?.photo_url
                      ? <img src={`${process.env.REACT_APP_API_URL}${me.photo_url}`} alt={initials} />
                      : initials}
                </span>
                <span className="rb-usermeta">
                  <span className="rb-username">{displayName}</span>
                  <span className="rb-userrole">{roleLabel}</span>
                </span>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7"><polyline points="6 9 12 15 18 9" /></svg>
              </button>
            </div>
      </aside>
    </>
  );
}
